export const withEventValue = (func: (value: string) => any) => (
  event: React.ChangeEvent<HTMLInputElement>
) => func(event.currentTarget.value);
